export const SUPER_ADMIN = 'SUPER_ADMIN'
export const ADMIN = 'ADMIN'
export const DIRECTOR = 'DIRECTOR'
export const BACHELOR_STUDENT = 'BACHELOR_STUDENT'
export const MASTER_STUDENT = 'MASTER_STUDENT'
export const STAFF = 'STAFF'
export const GUEST_USER = 'GUEST_USER'
export const SYSTEM_MODERATOR = 'SYSTEM_MODERATOR'
export const QUALITY_ASSURANCE = 'QUALITY_ASSURANCE'
export const QUALITY_ASSURANCE_HEAD = 'QUALITY_ASSURANCE_HEAD'
export const TEACHER = 'TEACHER'
export const TEACHER_DISTANCE_LEARNING = 'TEACHER_DISTANCE_LEARNING'
export const MODULE_LEADER = 'MODULE_LEADER'
export const ACADEMIC_MENTOR = 'ACADEMIC_MENTOR'
export const HR_HEAD = 'HR_HEAD'
export const HR_MANAGER = 'HR_MANAGER'
export const REGISTRAR_HEAD = 'REGISTRAR_HEAD'
export const REGISTRAR_OFFICER = 'REGISTRAR_OFFICER'
export const REGISTRAR_HELPER = 'REGISTRAR_HELPER'
export const PROGRAMME_MANAGER = 'PROGRAMME_MANAGER'
export const AR_COMMITTEE = 'AR_COMMITTEE'
export const EXTRACURRICULAR_ACTIVITY_MANAGER = 'EXTRACURRICULAR_ACTIVITY_MANAGER'
export const MODERATOR_VIEWER = 'MODERATOR_VIEWER'
export const TEACHING_AND_LEARNING_OFFICER = 'TEACHING_AND_LEARNING_OFFICER'
export const MS_APPLICANT = 'MS_APPLICANT'
export const BS_APPLICANT = 'BS_APPLICANT'
export const MS_STUDENT = 'MS_STUDENT'
export const SHORT_TERM_COURSE_LISTENER = 'SHORT_TERM_COURSE_LISTENER'
export const LIBRARY_MODERATOR = 'LIBRARY_MODERATOR'
export const TEST_STUDENT = 'TEST_STUDENT'
export const DEMO_ADMIN = 'DEMO_ADMIN'
export const ADMISSION_MODERATOR = 'ADMISSION_MODERATOR'
export const ADMISSION_VIEWER = 'ADMISSION_VIEWER'
export const ADMISSION_APPLICANT = 'ADMISSION_APPLICANT'
export const DEAN = 'DEAN'
export const MARKETING = 'MARKETING'
export const FINANCE_HEAD = 'FINANCE_HEAD'
export const INQUIRY_MODERATOR = 'INQUIRY_MODERATOR'
export const EXAM_UNIT = 'EXAM_UNIT'
export const LEGAL = 'LEGAL'
export const PSYCHOLOGIST = 'PSYCHOLOGIST'
export const PRE_FOUNDATION_STUDENT = 'PRE_FOUNDATION_STUDENT'
export const EXTERNAL_VIEWER = 'EXTERNAL_VIEWER'
export const COURSE_LEADER = 'COURSE_LEADER'
export const HEAD_OF_KAFEDRA = 'HEAD_OF_KAFEDRA'
export const EXTERNAL_LINKED_TUTOR = 'EXTERNAL_LINKED_TUTOR'
export const PASSWORD_RESET_USER = 'PASSWORD_RESET_USER'
export const ACCOUNTANT_MODERATOR = 'ACCOUNTANT_MODERATOR'
export const ACCOUNTANT_HEAD = 'ACCOUNTANT_HEAD'
export const VICE_RECTOR = 'VICE_RECTOR'
export const DISTANCE_LEARNING_STUDENT = 'DISTANCE_LEARNING_STUDENT'
export const PROCUREMENT_HEAD = 'PROCUREMENT_HEAD'
export const DMS_MODERATOR = 'DMS_MODERATOR'
export const SHOP_MODERATOR = 'SHOP_MODERATOR'
export const STUDENT_SUPPORT_UNIT = 'STUDENT_SUPPORT_UNIT'
export const CONFERENCE_TECHNICAL_REVIEWER = 'CONFERENCE_TECHNICAL_REVIEWER'
export const CONFERENCE_PUBLICATION_AUTHOR = 'CONFERENCE_PUBLICATION_AUTHOR'
export const CONFERENCE_ARTICLE_HEAD_EDITOR = 'CONFERENCE_ARTICLE_HEAD_EDITOR'
export const CONFERENCE_MAGAZINE_DESIGNER = 'CONFERENCE_MAGAZINE_DESIGNER'
export const ICONFERENCE_ARTICLE_HEAD_EDITOR = 'ICONFERENCE_ARTICLE_HEAD_EDITOR'
export const ICONFERENCE_TECHNICAL_REVIEWER = 'ICONFERENCE_TECHNICAL_REVIEWER'
export const IT_HELPDESK_OPERATOR = 'IT_HELPDESK_OPERATOR'
export const ADMINISTRATION_OFFICE_OFFICER = 'ADMINISTRATION_OFFICE_OFFICER'
export const EXTERNAL_LETTER_MANAGER = 'EXTERNAL_LETTER_MANAGER'
